module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp2-4b22e50fd32ea368a57f5553b183ecf9.jpg";